import { IChartContainer } from "../../models/base/chart-container.interface";
import { IComponent } from "../component.interface";

export class CameraScrenshotComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;

    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element
        this.base = base;
        this.onClick();
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            this.base.chartService.requestCameraTakeScreenshot();
        });
    }
}